<template>
  <data-list
    ref="dataList"
    class="content md"
    url="/activity/activity-task-temp"
    entity-name="任务场景"
    add-btn="添加任务场景"
    hide-show-detail
    :before-edit="beforeEdit"
    :before-update="beforeUpdate"
    :action="action"
    :columns="columns"
    :rules="rules"
    :modal-width="640"
    :modal-form="modalForm"
  >
    <template v-slot:edit="{ form }">
      <a-form-model-item label="任务名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入任务名称"></a-input>
      </a-form-model-item>
      <a-form-model-item label="操作手册">
        <file-upload v-model="form.files" :limit="1" />
      </a-form-model-item>
      <a-form-model-item label="权限设置" prop="module">
        <module-setting v-model="form.module" />
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
    import {omit} from "../common/js/tool";

    export default {
        name: "Scene",
        data() {
            return {
                rules: {
                    name: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
                    module: [{ required: true, message: '请设置任务功能权限', trigger: 'change' }],
                },
                columns: [
                    {title: '固定任务场景', dataIndex: 'name'},
                ],
                modalForm: {
                    layout: 'horizontal',
                    labelCol: { span: 4 },
                    wrapperCol: { span: 20 },
                }
            }
        },
        computed: {
            action() {
                return this.$route.meta.action;
            },
        },
        methods: {
            beforeEdit(form, fn) {
                const data = omit(form, ['file', 'module_ids']);
                if(form.file) {
                    data.files = JSON.parse(form.file);
                }
                if(form.module_ids) {
                    data.module = form.module_ids.split(",");
                }
                fn(data);
            },
            beforeUpdate(form, fn) {
                const data = omit(form, ['files', 'module']);
                data.file = form.files ? JSON.stringify(form.files) : null;
                data.module_ids = form.module && form.module.length > 0 ? form.module.join(",") : null;
                fn(data);
            }
        }
    }
</script>

<style scoped>

</style>
